import React from 'react';
interface IconProps {
  width?: number;
  height?: number;
}

const HomeValueIconAppartement = (props: IconProps) => {
  return (
    <svg
      width={56}
      height={53}
      viewBox="0 0 56 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M48.222 52.222V.889H16.333v51.333"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
      <path
        d="M7 51.443V5.554h7"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinejoin="round"
        d="M22.556 6.334h7.778v7.778h-7.778zM22.556 18.875h7.778v7.778h-7.778zM35 6.334h7.778v7.778H35zM35 18.875h7.778v7.778H35zM42.753 52.135V32.184H22.231v19.951"
      />
      <path
        d="M32.667 34.334v17.889M56 52.223H-1.556"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </svg>
  );
};

export default HomeValueIconAppartement;
